module.exports = __webpack_public_path__ + "static/media/intel-1.5378ec84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/intel-1.svg
// module id = 1112
// module chunks = 2